module.exports = __webpack_public_path__ + "static/media/natural-threats_bg.0cb5752a.jpg";